import React from 'react';
import PropTypes from 'prop-types';

const IENoSettingsDataFound = ({ title, message }) => {
  return (
    <div className="ie--card it-settings--category">
      <div className="ie--card--body">
        <div className="ie--card--col">
          <h2 className="ie--card--title">{title}
          </h2>
          <div>
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};

IENoSettingsDataFound.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
};

export default IENoSettingsDataFound;
